import React from 'react';

import { Container, Row, Col } from 'reactstrap';
import { Modal, ModalBody } from 'reactstrap';

import CSS from './CrewList.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const crewList = props => {
  let className = '';
  if (props.pageWidth < 992) {
    className = 'pt-5 mt-5 w-100';
  } else {
    className = 'abs-container d-flex align-items-center';
  }

  const modalData = props.crewData.find(x => x.id === props.modalContentId);
  return (
    <div className={className}>
      <Container
        className={'scrollable'}
        style={props.heightSm ? { height: '75%' } : { height: '615px' }}
      >
        <Row className={CSS.container}>
          {props.crewData.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <Col
                  key={index}
                  xs={12}
                  sm={6}
                  md={3}
                  lg={2}
                  className={'d-flex flex-column'}
                >
                  <div className={CSS.image + ' d-flex align-items-center'}>
                    <div>
                      {item.avatar !== '' && (
                        <img
                          src={item.avatar}
                          alt={item.name}
                          className={'img-fluid'}
                        />
                      )}
                    </div>
                  </div>
                  <div className={CSS.name + ' flex-fill'}>{item.name}</div>
                  <div className={CSS.role}>{item.role}</div>

                  <div
                    className={
                      props.extended.indexOf(item.id) !== -1 &&
                      props.pageWidth < 992
                        ? 'd-block'
                        : 'd-none'
                    }
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                  <Row
                    className={CSS.expand + ' pointer'}
                    onClick={() => props.toggleExtended(item.id)}
                  >
                    <Col xs={10}>
                      <div className={CSS.border} />
                    </Col>
                    <Col xs={2} className={'pl-0'}>
                      {props.extended.indexOf(item.id) !== -1 &&
                      props.pageWidth < 992 ? (
                        <FontAwesomeIcon
                          icon={['fas', 'minus']}
                          className={'float-right mt-1'}
                        />
                      ) : (
                        <FontAwesomeIcon
                          icon={['fas', 'plus']}
                          className={'float-right mt-1'}
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
                {(index === 10 || index === 12) && <div className={'w-100'} />}
              </React.Fragment>
            );
          })}
        </Row>
      </Container>

      {props.pageWidth > 991 && (
        <Modal
          isOpen={props.modal}
          toggle={() => props.toggleExtended(props.modalContentId)}
          className={
            'modal-lg h-100 d-flex flex-column justify-content-center my-0'
          }
        >
          <ModalBody>
            {modalData !== undefined && (
              <Row className={CSS.container + ' mb-0'}>
                <Col xs={4}>
                  <div
                    className={CSS.image + ' d-inline-block'}
                    style={{ height: 'auto' }}
                  >
                    <div>
                      <img
                        src={modalData.avatar}
                        alt={modalData.name}
                        className={'img-fluid'}
                      />
                    </div>
                  </div>
                  <div className={CSS.name}>{modalData.name}</div>
                  <div className={CSS.role}>{modalData.role}</div>
                  <Row className={CSS.expand}>
                    <Col xs={10}>
                      <div className={CSS.border + ' mb-0'} />
                    </Col>
                  </Row>
                </Col>
                <Col xs={8}>
                  <div
                    dangerouslySetInnerHTML={{ __html: modalData.description }}
                  />
                </Col>
              </Row>
            )}
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default crewList;



// WEBPACK FOOTER //
// ./src/components/Leadership/CrewList/CrewList.jsx